<template>
  <div class="yealuck-2023-input-base">
    <div class="block-package-info"  :style="styles">
      <div class="info-wrap">
        <div class="info-top">
          <img :src="packageInfo.input.thumbnail" :alt="packageInfo.server.name" class="info-top_thum">
          <div class="counselor-info">
            <span class="counselor-name">{{packageInfo.server.name}}</span>
            <span class="package-title">{{packageInfo.server.pkgTitle}}</span>
            <span class="price-wrap">
              <span class="price" v-html="formatPrice(packageInfo.server.price)"></span>
              <span class="small">（税込）</span>
            </span>
            <span class="price-wrap">
              <span class="small">会員価格</span>
              <span class="price" v-html="formatPrice(packageInfo.server.member_price)"></span>
              <span class="small">（税込）</span>
            </span>
          </div>
        </div>
        <p class="package-description" v-html="packageInfo.server.pkgDescription"></p>
      </div>
    </div>

    <div class="btn-area">
      <basic-button
        class="btn-submit btn-free-divination"
        @btn-click="onFreeDivinationClick"
        :has-shadow="true"
        :btn-disabled="allowFreeSubmit"
      >一部無料で占う</basic-button>
    </div>

    <div class="block-greeting-message">
      <img :src="packageInfo.input.fukiImage" :alt="packageInfo.server.name" class="block-greeting-message_img">
    </div>

    <div class="block-submenus-list">
      <h2><img :src="`${imgPath}input/head_input_submenus.png`" alt="このメニューで占える項目" class="block-submenus-list_title"></h2>
      <ul class="block-submenus-list_ul">
        <li class="block-submenus-list_li" v-for="(item, idx) in packageInfo.server.submenu_list" :key="idx">{{item}}</li>
      </ul>
      <div class="notice" v-if="packageInfo.info.pkgNotice" v-html="packageInfo.info.pkgNotice"></div>
    </div>

    <div class="block-input-form">
      <h2><img :src="`${imgPath}input/head_input_forms.png`" alt="このメニューで占える項目" class="block-submenus-list_title"></h2>
      <form :action="targetAction" method="post" ref="form">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="is_free" :value="sendIsFree">
        <form-birthday
          v-model="birthday"
          name="birth_date"
          label="生年月日"
          placeholderYear="1999"
          placeholderMonth="12"
          placeholderDay="31"
          :validation="{ rules: {birthRange: true, required: true} }"
        />
        <form-input
          name="nickname"
          v-model="nickname"
          type="text"
          placeholder="ニックネーム"
          label="ニックネーム"
          :validation="{ rules: {
          required: true,
          max: 15
        } }"
        ></form-input>
        <div class="btn-area">
          <basic-button
            class="btn-submit btn-free-menu"
            @btn-click="onSubmitFreeMenu"
            :has-shadow="true"
            :btn-disabled="!allowFreeSubmit"
          >一部無料で占う</basic-button>
        </div>
        <span class="notice">※一部無料結果では結果テキストの一部をご覧いただけます</span>
        <div class="btn-area">
          <basic-button
            class="btn-submit btn-paid-menu"
            @btn-click="onSubmitPaidMenu"
            :has-shadow="true"
            :btn-disabled="!allowPaidSubmit"
          >有料で占う</basic-button>
        </div>
        <span class="notice">※通常価格999円（税込）、占いTV月額会員の方は500円（税込）でご購入いただけます。</span>
      </form>
    </div>

    <sell-point
      :nomal-price="packageInfo.server.price"
      :member-price="packageInfo.server.member_price"
      :sbsc-url="sbscUrl"
    />

    <lp-footer :menu-list="footerMenuList" />
  </div>
</template>

<script>
import {PACKAGE_INFO} from './data/consts'
import BasicButton from './partials/BasicButton'
import SellPoint from './partials/SellPoint'
import { DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'


export default {
  name: 'Yearluck2023Input',
  components: {
    BasicButton,
    SellPoint,
    LpFooter,
  },
  props: {
    receivedPackageInfo: {
      type: Object,
      required: true,
    },
    targetAction: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    sbscUrl: {
      type: String,
    },
    subscriptionFlg: {
      type: Boolean,
      defaut: false,
    },
  },
  data() {
    return {
      lock: false,
      birthday: '',
      nickname: '',
      buttonIsDisabled: false,
      imgPath: '/static/img/yearluck/y2023/',
      sendIsFree: 0,
    }
  },
  computed: {
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
    allowFreeSubmit() {
      return this.birthday.length > 0
        && /((?:19|20)\d\d)([0-1]\d)([0-2]\d)/.test(this.birthday)
        && this.nickname.length > 0
    },
    allowPaidSubmit() {
      return this.allowFreeSubmit
    },
    packageInfo() {
      const info = PACKAGE_INFO.find(infoitem => infoitem.info.itemId === +this.receivedPackageInfo.item_id)
      return {
        server: this.receivedPackageInfo,
        ...info,
      }
    },
    styles() {
      return {
        // 'background-image': `url(${this.packageInfo.input.pkgBackImg})`,
        '--pkginfo-bg-upper': `url(${ this.packageInfo.input.headInfoBgUpp })`,
        '--pkginfo-bg-middle': `url(${ this.packageInfo.input.headInfoBgMdl })`,
      }
    }
  },
  mounted() {
    // console.log('生成したデータ[%O]', this.packageInfo)
  },
  methods: {
    formatPrice(val) {
      const price = String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return `￥${price}`
    },
    onFreeDivinationClick() {
      const tgt = this.$el.querySelector('.block-input-form')
      const head = document.querySelector('header.header')
      const offset = 8
      window.scrollTo({top: tgt.getBoundingClientRect().top + window.scrollY - head.clientHeight - offset, behavior: 'smooth'})
    },
    onSubmitFreeMenu() {
      // console.log('一部無料で占うサブミット')
      if(!this.lock){
        this.lock = true
        this.sendIsFree = 1
        setTimeout(() => {
          this.$refs.form.submit()
        }, 100)
      }
    },
    onSubmitPaidMenu() {
      // console.log('有料で占うサブミット')
      // is_free = 1 無料 0 有料
      if(!this.lock){
        this.lock = true
        this.sendIsFree = 0
        setTimeout(() => {
          this.$refs.form.submit()
        }, 100)
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

#app {
  background: #f8edb6;
}

.yealuck-2023-input-base{
  background-color: #f8edb6;
  background-image: url(/static/img/yearluck/y2023/bg_main.svg);
  background-size: 100%;
  background-repeat: repeat-y;
  padding-top: 20px;
  @include mq('w580'){
    margin-bottom: -40px;
  }
}

.block-package-info {
  background-size: 100%;
  color:#fff;
  padding: 0 16px;
  margin: 0 0 20px;
  background-repeat: no-repeat;
  min-height: 281px;
  position: relative;
  .info-wrap {
    background-size: 100% auto;
    position: relative;
    padding: 6.86% 0;
    &::before,
    &::after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 0;
      padding-top: 6.86%;
      position: absolute;
    }
    &::before {
      background: var(--pkginfo-bg-upper) no-repeat center top;
      background-size: 100% auto;
      top: 1px;
      left: 0;
    }
    &::after {
      background: var(--pkginfo-bg-upper) no-repeat center top;
      background-size: 100% auto;
      transform: rotate(180deg);
      bottom: 1px;
      left: 0;
    }
    .info-top{
      display: flex;
      background: var(--pkginfo-bg-middle) repeat-y center top;
      background-size: 100% auto;
      padding: 0 16px;
      @include mq('w580') {
        padding: 0 24px;
      }
      .info-top_thum{
        width: 132px;
        height: 132px;
        margin-right: 8px;
        @include mq('w580'){
          height: 185px;
          width: 185px;
          margin-right: 18px;
        }
      }
      .counselor-name {
        display: inline-block;
        border-radius: 6px;
        background: #333;
        padding: 5px 8px;
        font-size: 12px;
        font-weight: 600;
        line-height: 14px;
        margin-bottom: 6px;
      }

      .package-title {
        display: block;
        font-weight: 600;
        font-size: 15px;
        line-height: 21px;
        border-bottom: 1px solid #fff;
        padding-bottom: 8px;
        margin-bottom: 8px;
        @include mq('w580'){
          font-size: 18px;
        }
      }
    }
    .package-description {
      background: var(--pkginfo-bg-middle) repeat-y center top;
      background-size: 100% auto;
      font-weight: 300;
      font-size: 13px;
      line-height: 20px;
      padding: 16px 16px 0;
      margin: 0;
      min-height: 116px;
      @include mq('w580'){
        font-size: 16px;
        line-height: 20px;
        padding: 20px 24px 0;
      }
    }
  }
  @include mq('w580'){
    padding: 0 36px;
  }
}


.lock-greeting-message_img{
  width: 100%;
}



.small {
  font-size: 10px;
}

.price-wrap {
  display: block;
  text-align: right;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.block-greeting-message_img{
  width: 100%;
}

.btn-submit {
  &.basic-button {
    font-size: 14px;
    &.btn-free-divination{
      width:240px;
      margin: auto;
      display: block;
      margin-bottom: 24px;
      height: 44px;
    }
  }
}

.block-greeting-message {
  margin-bottom: 24px;
}

.block-submenus-list_title{
  width:100%;
}

.block-submenus-list{
  margin: 0 20px 32px;
  position: relative;
  h2 {
    width:100%;
    margin: 0;
    position: relative;
    z-index: 10;
    img {
      width: 100%;
      display: block;
    }
  }
  & > ul {
    margin: 0 0 12px;
    padding: 0 24px;
    background: url(/static/img/yearluck/y2023/input/bg_submenu_inner.png);
    background-size: 100%;
    position: relative;
    margin-top: -23px;
    padding-top: 23px;
    &::after{
      content: '';
      display: block;
      background: url(/static/img/yearluck/y2023/input/bg_submenu_footer.png) no-repeat center bottom;
      width: 100%;
      height: 13px;
      background-size: 100%;
      position: absolute;
      bottom: -4px;
      left: 0;
    }
    & > li {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #fff;
      list-style: none;
      padding: 14px 0 14px 16px;
      border-bottom: 1px dashed #aab2bd;
      position: relative;
      &::after {
        content: "";
        display: block;
        border-radius: 9999px;
        width: 8px;
        height: 8px;
        background: white;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      &:last-child{
        border: none;
      }
    }
  }
  .notice {
    color: #412e2e;
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    padding: 0 4px;
  }
}

.block-input-form{
  margin: 0 20px 24px;
  .notice {
    margin: 8px 0;
    display: block;
    font-weight: 300;
    font-size: 10px;
    line-height: 15px;
    text-align: center;
    color: #000;
  }
}

/deep/ {
  .block-input-form {
    .calenderForm {
      width: 100%;
      background: #fff;
      border-radius: 5px;
      justify-content: center;
      padding: 0;
    }
    .calenderForm[data-error='true'] {
      background-color: #fff4f5;
    }
    .form-input__input {
      background: #fff;
      text-align: center;
    }
    .form-label {
      display: none;
    }
    .year {
      max-width: 60px;
    }
    .month {
      max-width: 40px;
    }
    .day {
      max-width: 40px;
    }
  }
  .btn-submit.basic-button.btn-free-divination {
    .text-wrap {
      min-height: 44px;
    }
  }
}
</style>


<style>
#app {
  height: 100%;
  overflow: hidden;
}
.nav-footer {
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2023/Yearluck2023Input.vue